import { RemoveConfirmationAlert } from '@components/dialogs/removeConfirmationAlert';
import { Button } from '@components/ui/button';
import { SvgConsumer } from '@components/icons/svgConsumer';
import { useRemoveTask } from '@services/jobs/tasks/remove';
import { useTranslation } from 'react-i18next';
import { useJobContext } from '@contexts/job';
import { JobTaskRemoveProps } from './types';
import { useAccess } from '@hooks/access';

export const JobTaskRemove = ({
  data,
  jobId,
  size = 'sm',
  iconClassName = 'text-m',
}: JobTaskRemoveProps) => {
  const { archived, job } = useJobContext();

  const { t } = useTranslation('app');
  const access = useAccess();

  const removeTask = useRemoveTask(data.stageId);

  const resolvedJobId = jobId || job?.data?.data.id || '';

  return (
    <RemoveConfirmationAlert
      title={t('pages.job.removeTask.title')}
      description={t('pages.job.removeTask.description', { name: data.name })}
      onConfirm={() => removeTask.mutate({ jobId: resolvedJobId, id: data.id })}
      locked={removeTask.isLoading}>
      <Button
        data-testid={`remove-task-${data.name}`}
        title={t('actions.removeTask')}
        disabled={archived || access.cad}
        variant="ghost"
        size={size}
        className={size === 'sm' ? 'px-2' : undefined}>
        <SvgConsumer id="taskRemove" className={iconClassName} />
        <span className="sr-only">{t('actions.removeTask')}</span>
      </Button>
    </RemoveConfirmationAlert>
  );
};
